type Messages = {
  new: {
    allowed: string;
    notAllowed?: string;
  };
  edit: {
    allowed: string;
  };
};

type GetInfoMessageParams = {
  messages: Messages;
  isNew?: boolean;
  allowEdit: boolean;
  hasAnyFormField?: boolean;
};

export const getInfoMessage = ({
  isNew,
  allowEdit,
  hasAnyFormField = true,
  messages
}: GetInfoMessageParams) => {
  if (isNew) {
    return allowEdit ? messages.new.allowed : messages.new.notAllowed;
  }

  if (!hasAnyFormField) {
    return null;
  }

  return allowEdit ? messages.edit.allowed : null;
};
